import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGINATION_DEFAULT } from 'utils/constants';
import { SCREEN_TYPE } from 'utils/enums';

const initialState: IInventoryProgressState = {
    screenMode: SCREEN_TYPE.list,
    formSearch: undefined,
    paginateMetaData: PAGINATION_DEFAULT,
    sort: '',
    selectedItems: [],
    keywordSearch: [],
    selectedItem: {
        id: '',
        name: '',
        status: 0,
        responsible_user_id: '',
        planned_date: '',
        create_at: '',
        update_at: '',
        comment: '',
    },
};

export const inventoryProgressSlice = createSlice({
    name: 'inventoryProgress',
    initialState,
    reducers: {
        // <> STATE <>
        init: () => initialState,

        // set mode screen: LIST <> DETAIL <> REGISTER (in task page)
        setMode: (state, action: PayloadAction<SCREEN_TYPE>) => {
            state.screenMode = action.payload;
        },
        // set search conditions
        setFormSearch: (state, action: PayloadAction<IInventoryProgressSearch | undefined>) => {
            state.formSearch = action.payload;
        },
        // set keywords search conditions
        setKeywordSearch: (state, action: PayloadAction<string[]>) => {
            state.keywordSearch = action.payload;
        },
        // set sort column like "column_name:asc|desc"
        setSort: (state, action: PayloadAction<string>) => {
            state.sort = action.payload;
        },
        // set pagination meta data
        setPaginateMetaData: (state, action: PayloadAction<Pagination>) => {
            state.paginateMetaData = action.payload;
        },
        // set selected items
        setSelectedItems: (state, action: PayloadAction<number[]>) => {
            state.selectedItems = action.payload;
        },
        // set selected item
        setSelectedItem: (state, action: PayloadAction<IInventoryProgress>) => {
            state.selectedItem = action.payload;
        },
    },
});

export const {
    setSort,
    setPaginateMetaData,
    setMode,
    setSelectedItems,
    setFormSearch,
    setKeywordSearch,
    setSelectedItem,
    init,
} = inventoryProgressSlice.actions;

export default inventoryProgressSlice.reducer;
